import params from './params';
import messages from './messages';

export default {
    getParam(name) {
        return params[name];
    },

    getMessage(name) {
        return messages[name];
    },
};